export default "__VITE_ASSET__Co0NLhFf__"